var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    opacity: 0.4,
    d: "M15.4974 10.6293C15.4974 12.4893 14.0041 13.9959 12.1441 14.0026H12.1374H5.53073C3.6774 14.0026 2.16406 12.5026 2.16406 10.6426V10.6359C2.16406 10.6359 2.16806 7.68527 2.1734 6.20127C2.17406 5.9226 2.49406 5.7666 2.71206 5.93994C4.29606 7.1966 7.12873 9.48794 7.16406 9.51794C7.6374 9.89727 8.2374 10.1113 8.85073 10.1113C9.46406 10.1113 10.0641 9.89727 10.5374 9.5106C10.5727 9.48727 13.3421 7.2646 14.9501 5.98727C15.1687 5.81327 15.4901 5.96927 15.4907 6.24727C15.4974 7.71994 15.4974 10.6293 15.4974 10.6293",
    fill: "#92929E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    d: "M15.1486 3.78267C14.5713 2.69467 13.4353 2 12.1846 2H5.5313C4.28064 2 3.14464 2.69467 2.5673 3.78267C2.43797 4.026 2.4993 4.32933 2.71464 4.50133L7.66464 8.46067C8.0113 8.74067 8.4313 8.88 8.8513 8.88C8.85397 8.88 8.85597 8.88 8.85797 8.88C8.85997 8.88 8.86264 8.88 8.86464 8.88C9.28464 8.88 9.70464 8.74067 10.0513 8.46067L15.0013 4.50133C15.2166 4.32933 15.278 4.026 15.1486 3.78267",
    fill: "#92929E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4d1fa73df198995a4d34a47b6a13da73.svg";
export { ForwardRef as ReactComponent };